// extracted by mini-css-extract-plugin
export default {"container":"ProfileMyPlans_container__nBdE8","img":"ProfileMyPlans_img__agTcy","title":"ProfileMyPlans_title__T9LIZ"};